import React, { Fragment, useEffect, useState } from "react";
import { Card, Col, Container, Input, Row } from "reactstrap";
import CardHeaderSpan from "../../Utils/CommonComponents/CardHeaderSpan";
import { API } from "../../api/API";
import { getData } from "../../CommonElements/Functions/PostGetFun";
import { getFilteredPositionIds } from "../../db/DexieServises";
import MonthDropdown from "../CommonCompo/MonthDropdown";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import FeatherIconCom from "../../Utils/CommonComponents/CommonIcons/FeatherIconCom";
import { dynamicImage } from "../../Utils";
import { Image } from "../../AbstractElements";
import { useSelector } from "react-redux";
import { RootState } from "../../redux-toolkit/store";
import TreeModel from "../Dashboards/Attendance/AttendanceTable/TreeModel";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

interface MtpDetailData {
  EmployeeName: string;
  EmployeePosition: string;
  Month: string;
  Status: string;
  ApprovedBy: string;
  ApprovedDate: string;
  Date: string;
  agendaconrtol_type: string;
  OutlrtTypeWiseCount: string;
  TotalOutletCount: number;
  Towns: string;
  Beats: string;
  AgendaName: string;
}

export default function MTPSummary() {
  const unitId = useSelector((state: RootState) => state.orgUnit.id);
  const [searchText, setSearchText] = useState("");
  const [selectedIds, setSelectedIds] = useState<(string | number)[]>([]);
  const [mtpData, setMtpData] = useState<MtpDetailData[]>([]);
  const [displayedData, setDisplayedData] = useState<MtpDetailData[]>([]);
  // const [selectedMonth, setSelectedMonth] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [filterMonth, setFilterMonth] = useState<string>("");
  console.log("=============== filterMonth ===============", filterMonth);

  const serverUrl = localStorage.getItem("serverUrl");

  // Replaced MonthDropdown with a custom dropdown for months
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const currentMonth = new Date();
  const months = [
    new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 4, 1),
    new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 3, 1),
    new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 2, 1),
    new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1),
    new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1),
    new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1),
  ];

  // Use a local YYYY-MM formatter to avoid timezone shifts caused by toISOString()
  // const formatYYYYMM = (d: Date) =>
  //   `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;

  // MMYY format (e.g. 0126 for Jan 2026)
  const formatMMYYYY = (d: Date) =>
  `${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;

  // const dropdownOptions = months.map(
  //   (date) =>
  //     [
  //       formatYYYYMM(date),
  //       date.toLocaleString("default", { month: "short", year: "numeric" }),
  //     ] as [string, string],
  // );
  const dropdownOptions = months.map(
    (date) =>
      [
        formatMMYYYY(date), // "MM-YYYY"
        date.toLocaleString("default", { month: "short", year: "numeric" }),
      ] as [string, string],
  );
  const [selectedKey, setSelectedKey] = useState<string>(dropdownOptions[4][0]); // Default to the future month

  const handleSelect = (key: string) => {
    setSelectedKey(key);
    setLoading(true); // show loader immediately when user changes month
    // setLoader(true);
    setFilterMonth(key);
  };

  // Ensure the filterMonth is initialized to the default future month on mount
  React.useEffect(() => {
    if (!filterMonth && selectedKey) {
      setLoading(true); // show loader when initializing default month
      setFilterMonth(selectedKey);
    }
    // We intentionally run this only when selectedKey changes on first render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedKey]);

  // Format date from "2025-12-01" to "1/12/2025"
  const formatDate = (dateStr: string) => {
    if (!dateStr) return "-";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
  };

  // Format approved date from "2025-12-01" to "1-Dec-25"
  const formatApprovedDate = (dateStr: string) => {
    if (!dateStr) return "-";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    const day = d.getDate();
    const month = d.toLocaleString("en", { month: "short" });
    const year = d.getFullYear().toString().slice(-2);
    return `${day}-${month}-${year}`;
  };

  // Format month from "12-2025" to "Dec-25"
  const formatMonth = (monthStr: string) => {
    if (!monthStr) return "-";
    const [month, year] = monthStr.split("-");
    const monthNum = parseInt(month, 10) - 1;
    const monthName = new Date(2000, monthNum).toLocaleString("en", {
      month: "short",
    });
    const shortYear = year.slice(-2);
    return `${monthName}-${shortYear}`;
  };

  // Truncate text with ellipsis
  const truncateText = (
    text: string | null | undefined,
    maxLength: number = 40,
  ): string => {
    if (!text) return "-";
    return text.length > maxLength
      ? `${text.substring(0, maxLength)}...`
      : text;
  };

  // Fetch position IDs when unitId changes
  useEffect(() => {
    const fetchPositionIds = async () => {
      if (unitId) {
        const ids = await getFilteredPositionIds("Position", unitId);
        setSelectedIds(ids);
      }
    };
    fetchPositionIds();
  }, [unitId]);

  // Call API when month or positions change
  useEffect(() => {
    if (filterMonth) {
      handleSubmitAPI();
    }
  }, [filterMonth, selectedIds, unitId]);

  const handleSubmitAPI = async () => {
    if (!serverUrl) {
      console.error("Missing server URL");
      return;
    }
    setLoading(true);

    const url = `${serverUrl}${API.MtpDetailReport}`;
    const { status, data } = await getData(url, true, {
      moye: filterMonth,
    });

    if (status === 200 && Array.isArray(data?.data)) {
      setMtpData(data.data);
    } else {
      setMtpData([]);
    }
    setLoading(false);
  };

  // Filter data based on search text
  useEffect(() => {
    const lower = searchText.toLowerCase();

    const filtered = mtpData.filter((item) => {
      return (
        item?.EmployeeName?.toLowerCase().includes(lower) ||
        item?.EmployeePosition?.toLowerCase().includes(lower) ||
        item?.Status?.toLowerCase().includes(lower) ||
        item?.ApprovedBy?.toLowerCase().includes(lower) ||
        item?.Beats?.toLowerCase().includes(lower) ||
        item?.Towns?.toLowerCase().includes(lower) ||
        item?.AgendaName?.toLowerCase().includes(lower)
      );
    });

    setDisplayedData(filtered);
  }, [searchText, mtpData]);

  // Group data by employee for display
  const groupDataByEmployee = (data: MtpDetailData[]) => {
    const grouped: { [key: string]: MtpDetailData[] } = {};
    data.forEach((item) => {
      const key = `${item.EmployeeName}-${item.EmployeePosition}-${item.Month}`;
      if (!grouped[key]) {
        grouped[key] = [];
      }
      grouped[key].push(item);
    });
    return grouped;
  };

  const groupedData = groupDataByEmployee(displayedData);

  // Export to Excel - grouped format like table view
  const handleExportToExcel = () => {
    const exportData: Record<string, any>[] = [];

    // Process grouped data to match table format
    Object.entries(groupedData).forEach(([key, items]) => {
      items.forEach((row, rowIndex) => {
        if (rowIndex === 0) {
          // First row of group - show all employee details
          exportData.push({
            "Employee Name": row.EmployeeName || "-",
            "Employee Position": row.EmployeePosition || "-",
            Month: formatMonth(row.Month),
            Status: row.Status || "-",
            "Approved By": row.ApprovedBy || "-",
            "Approved At": formatApprovedDate(row.ApprovedDate),
            Date: formatDate(row.Date),
            "Agenda Control Type": row.agendaconrtol_type || "-",
            "Beat Name": row.Beats || "-",
            "Total Outlet Count": row.TotalOutletCount || 0,
            "Outlet Type Wise Count": row.OutlrtTypeWiseCount || "-",
            "Town Name": row.Towns || "-",
            "Agenda Name": row.AgendaName || "-",
          });
        } else {
          // Subsequent rows - empty employee details, only date-wise data
          exportData.push({
            "Employee Name": "",
            "Employee Position": "",
            Month: "",
            Status: "",
            "Approved By": "",
            "Approved At": "",
            Date: formatDate(row.Date),
            "Agenda Control Type": row.agendaconrtol_type || "-",
            "Beat Name": row.Beats || "-",
            "Total Outlet Count": row.TotalOutletCount || 0,
            "Outlet Type Wise Count": row.OutlrtTypeWiseCount || "-",
            "Town Name": row.Towns || "-",
            "Agenda Name": row.AgendaName || "-",
          });
        }
      });
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "MTP Summary");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `MTP_Summary_${filterMonth}.xlsx`);
  };

  return (
    <div className="page-body p-2">
      <Card>
        <div className="d-flex justify-content-between align-items-center pt-2 pb-2">
          <CardHeaderSpan
            headingClassName="pb-0"
            back={true}
            heading="MTP Summary"
            span="MTP Detail Report"
          />
          <div className="p-3">
            {/* <MonthDropdown onChange={(value) => setSelectedMonth(value)} /> */}
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
              <DropdownToggle caret color="primary">
                {dropdownOptions.find(([key]) => key === selectedKey)?.[1] ||
                  "Select Month"}
              </DropdownToggle>
              <DropdownMenu>
                {dropdownOptions.map(([key, label]) => (
                  <DropdownItem key={key} onClick={() => handleSelect(key)}>
                    {label}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>

        <div className="row px-3 mb-3 align-items-center justify-content-between">
          <div className="col-md-8 d-flex align-items-center gap-3 flex-wrap">
            <Input
              type="text"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Search by name, position, status..."
              className="form-control"
              style={{ maxWidth: "280px" }}
            />
            <TreeModel onSelectionChange={setSelectedIds} />
          </div>

          <div className="col-md-4 d-flex justify-content-end gap-3">
            <button
              className="btn btn-sm btn-primary align-items-center d-flex"
              onClick={handleExportToExcel}
            >
              <FeatherIconCom
                iconName={"Download"}
                size={14}
                className="text-light"
              />
              <span className="px-2" style={{ fontSize: 14 }}>
                Export
              </span>
            </button>
          </div>
        </div>

        <Fragment>
          <Container fluid>
            <Row>
              <Col sm={12}>
                <div className="table-responsive">
                  {loading ? (
                    <div className="text-center py-3">
                      <div>
                        <Image
                          className="b-r-10 img-80"
                          src={dynamicImage("dashboard/loader.gif")}
                          alt="Loading..."
                        />
                      </div>
                    </div>
                  ) : (
                    <table className="table table-bordered text-center align-middle">
                      <thead className="table text-nowrap">
                        <tr>
                          <th>Employee Name</th>
                          <th>Employee Position</th>
                          <th>Month</th>
                          <th>Status</th>
                          <th>Approved By</th>
                          <th>Approved At</th>
                          <th>Date</th>
                          <th>Agenda Type</th>
                          <th>Beat Name</th>
                          <th>Total Outlets</th>
                          <th>Outlet Type Count</th>
                          <th>Town Name</th>
                          <th>Agenda Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.keys(groupedData).length > 0 ? (
                          Object.entries(groupedData).map(
                            ([key, items], groupIndex) => (
                              <Fragment key={key}>
                                {items.map((row, rowIndex) => (
                                  <tr key={`${key}-${rowIndex}`}>
                                    {rowIndex === 0 ? (
                                      <>
                                        <td
                                          rowSpan={items.length}
                                          title={row.EmployeeName}
                                          style={{
                                            verticalAlign: "top",
                                            textAlign: "left",
                                          }}
                                        >
                                          {truncateText(row.EmployeeName, 18)}
                                        </td>
                                        <td
                                          rowSpan={items.length}
                                          title={row.EmployeePosition}
                                          style={{
                                            verticalAlign: "top",
                                            textAlign: "left",
                                          }}
                                        >
                                          {truncateText(
                                            row.EmployeePosition,
                                            18,
                                          )}
                                        </td>
                                        <td
                                          rowSpan={items.length}
                                          style={{
                                            verticalAlign: "top",
                                            textAlign: "left",
                                          }}
                                        >
                                          {formatMonth(row.Month)}
                                        </td>
                                        <td
                                          rowSpan={items.length}
                                          style={{
                                            verticalAlign: "top",
                                            textAlign: "left",
                                            color:
                                              row.Status?.toLowerCase() ===
                                              "approved"
                                                ? "#28a745"
                                                : row.Status?.toLowerCase() ===
                                                    "rejected"
                                                  ? "#dc3545"
                                                  : "#ffc107",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {row.Status || "-"}
                                        </td>
                                        <td
                                          rowSpan={items.length}
                                          title={row.ApprovedBy}
                                          style={{
                                            verticalAlign: "top",
                                            textAlign: "left",
                                          }}
                                        >
                                          {truncateText(row.ApprovedBy, 15)}
                                        </td>
                                        <td
                                          rowSpan={items.length}
                                          style={{
                                            verticalAlign: "top",
                                            textAlign: "left",
                                          }}
                                        >
                                          {formatApprovedDate(row.ApprovedDate)}
                                        </td>
                                      </>
                                    ) : null}
                                    <td>{formatDate(row.Date)}</td>
                                    <td>{row.agendaconrtol_type || "-"}</td>
                                    <td
                                      title={row.Beats}
                                      style={{ textAlign: "left" }}
                                    >
                                      {truncateText(row.Beats, 40)}
                                    </td>
                                    <td>{row.TotalOutletCount || 0}</td>
                                    <td
                                      title={row.OutlrtTypeWiseCount}
                                      style={{ textAlign: "left" }}
                                    >
                                      {truncateText(
                                        row.OutlrtTypeWiseCount,40,)}
                                    </td>
                                    <td>{row.Towns || "-"}</td>
                                    <td>{row.AgendaName || "-"}</td>
                                  </tr>
                                ))}
                              </Fragment>
                            ),
                          )
                        ) : (
                          <tr>
                            <td colSpan={13}>No data available</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </Fragment>
      </Card>
    </div>
  );
}
